import Vue from 'vue'
export const identify = function (user) {
	intercom.boot(user)
}

export const intercom = {
	boot(user) {
		Vue.prototype.$intercom.boot({
			user_id: user.id,
			name: user.first_name + ' ' + user.last_name,
			email: user.email
		})
	},
	hide() {
		Vue.prototype.$intercom.shutdown()
	}
}

export const facebook = {
	boot(code) {
		try {
			window.fbq('init', code)
		} catch {}
	},
	track(event, params = {}) {
		try {
			window.fbq('track', event, params)
		} catch {}
	}
}
